import { ref } from "vue";
import KeenSlider, { KeenSliderInstance } from "keen-slider";
import { documentReady } from "@sazka/utils/document-ready";
import { onViewportEnter } from "@sazka/utils/viewport-enter";
import useCustomNavigationPlugin from "@/shared/keen-slider/plugins/keen-custom-navigation-plugin";
import { useKeenSliderConfig } from "../composables/use-keen-slider-config";

const initSlider = (widget: HTMLElement) => {
    const container = widget.querySelector<HTMLElement>(".cp-tickets-winners__slider");
    const dotsWrapper = ref<HTMLElement>(widget.querySelector<HTMLElement>(".cp-tickets-winners__navigation"));

    if (!container || !dotsWrapper.value) return;
    onViewportEnter(container, 0).then(() => {
        const sliderConfig = useKeenSliderConfig();
        sliderConfig.config.slides = {
            perView: 1,
        };

        const slider = new KeenSlider(container, sliderConfig, [useCustomNavigationPlugin(null, null, dotsWrapper)]);

        const timer = ref(0);
        slider.on("slideChanged", () => (timer.value = 0));

        const timerTick = (slider: KeenSliderInstance) => {
            if (timer.value < 4) {
                timer.value++;
                return;
            }

            if (slider.track.details.rel === slider.track.details.maxIdx) slider.moveToIdx(0);
            else slider.next();
        };

        setInterval(() => {
            timerTick(slider);
        }, 1000);
    });
};

documentReady(() => {
    const widgets = document.querySelectorAll<HTMLElement>(".cp-tickets-winners");
    widgets.forEach((widget) => {
        initSlider(widget);
    });
});
